export const VIOLATIONS_APPEARS = 'VIOLATIONS_APPEARS';

export const addViolation = (violations) => {
    return {
        type: VIOLATIONS_APPEARS,
        violations: violations,
    };
};

export const removeViolations = () => ({
    type: VIOLATIONS_APPEARS,
    violations: [],
});